import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	goalIconLabel: {
		id: 'spa-apps-sidebar-common.goal-icon.goal-icon-label',
		defaultMessage: 'Goal',
		description: 'ARIA label for the goal icon',
	},
});
